/**
 * A module for checking if a user or test is in QA.
 * @module abt-utils/qa
 */

import _ from 'lodash'
import * as queryString from '../abt-utils/query-string'

/**
 * Checks that the ABT Menu is running.
 * @returns {boolean} TRUE if a truthy is stored in the ABT Menu, otherwise FALSE.
 */
export function enabled () {
  return !!window.localStorage.abtestMenu
}

/**
 * Determines if the test is in QA.
 *
 * A test is only considered in QA when it has a version specified in the url for the
 * current test ID (i.e. www.bestbuy.com/?abt100=b) or the client is using the ABT Menu
 * and the test is in the QA list in local storage.
 *
 * @param {object} test - The current test object being evaluated.
 * @returns {boolean} TRUE if the test is in QA, otherwise FALSE.
 */
export function includes (test) {
  var urlHasVersion = !!queryString.get(test.id)
  var qaList = window.localStorage.abtestQA
  var isIncluded = !!(qaList && _.includes(qaList, test.id))

  return urlHasVersion || (enabled() && isIncluded)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/qa.js
 ** module id = 8
 ** module chunks = 2 3
 **/